<template lang="pug">
ubett(v-if="brand == 'BT'")
wbetnew(v-else-if="['WBET','IBCBET'].includes(brand)")
wbet(v-else)
</template>

<script>
import config from "@/config";

export default {
  components: {
    wbet: () => import("@/views/m/_wbet"),
    wbetnew: () => import("@/views/m/_wbetnew"),
    ubett: () => import("@/views/m/_ubett"),
  },
  data() {
    return {}
  },
  computed: {
    brand() {
      return config.brand;
    }
  },
  mounted() {},
  methods: {}
};
</script>
